// Modules
import { Store, select } from '@ngrx/store';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

// Components
import { ImagesDataModalComponent } from './images-data-modal/images-data-modal.component';

// Interfaces
import {
  IAccidentDetail,
  IDatosImagenes,
} from '@accidents/shared/interfaces/accidents';

// Constants
import {
  ESTADO_IMAGEN_SINIESTRO,
  FILE_TYPE,
} from '@accidents/shared/constants/index';

// Store
import { ModuleState } from '@app/modules/accidents/store/reducers';
import * as DetailAccidentSelectors from '@accidents/store/selectors/detail-accident.selectors';

@Component({
    selector: 'sbi-cot-back-images-data-tab',
    templateUrl: './images-data-tab.component.html',
    styleUrls: ['./images-data-tab.component.scss'],
    standalone: false
})
export class ImagesDataTabComponent implements OnInit {
  public estadoImagen = ESTADO_IMAGEN_SINIESTRO;
  public totalContenedores: number = 10;
  public accidentDetail: IAccidentDetail;
  public totalImagenes: number = 0;
  public contenedoresSinUsar: number;
  public contenedoresSinUsarArray: number[] = [];
  public fileType = FILE_TYPE;

  // Servicio detalle siniestros
  private _accidentDetail$ = this._store$.pipe(
    select(DetailAccidentSelectors.selectDetailAccident)
  );

  // Constructor
  constructor(
    private _matDialog: MatDialog,
    private _store$: Store<ModuleState>,
    private _sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    // Method to get the accident detail data
    this._parseDatosAccidente();
  }

  // Method to get the accident data
  private _parseDatosAccidente(): void {
    this._accidentDetail$.subscribe((accidentRequest: IAccidentDetail) => {
      if (accidentRequest) {
        this.accidentDetail = accidentRequest;
        if (this.accidentDetail.adjuntos) {
          this.totalImagenes = this.accidentDetail.adjuntos.length;
          this.totalContenedores = this.accidentDetail.adjuntosTotal;
        }
        this._setContenedoresSinUsar();
      }
    });

    this.accidentDetail.adjuntos.forEach(elem => {
      elem.safeUrl = this.getSafeUrl(elem);
    });
  }

  // Public method to set the safe url for the pdf
  public getSafeUrl(elem: IDatosImagenes): string {
    return this._sanitizer.bypassSecurityTrustResourceUrl(elem.url) as any;
  }

  private _setContenedoresSinUsar(): void {
    this.contenedoresSinUsar =
      this.totalContenedores -
      (this.accidentDetail.adjuntos ? this.accidentDetail.adjuntos.length : 0);
    for (let i = 1; i <= this.contenedoresSinUsar; i++) {
      this.contenedoresSinUsarArray.push(i);
    }
  }

  // Public method to show the selected image in a modal
  public zoomImage(image): void {
    this._matDialog.open(ImagesDataModalComponent, {
      data: { image: image },
    });
  }
}
